// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/index.scss
// module id = 2278
// module chunks = 13